import { render, staticRenderFns } from "./Adminitration_Mill.vue?vue&type=template&id=79cd2bac"
import script from "./Adminitration_Mill.vue?vue&type=script&lang=js"
export * from "./Adminitration_Mill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports